import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons"
import React from "react"
import { Link, RouteComponentProps, withRouter } from "react-router-dom"
import styled, { css } from "styled-components"
import Color from "../../../../style/enum/color"

interface IProps extends RouteComponentProps {
  to?: string
  className?: string
}

export const BackButton = withRouter((props: IProps) => {
  if (!props.to) {
    return (
      <WrapperButton onClick={props.history.goBack} className={props.className}>
        <FontAwesomeIcon icon={faChevronLeft} /> 戻る
      </WrapperButton>
    )
  }
  return (
    <WrapperLink to={props.to} className={props.className}>
      <FontAwesomeIcon icon={faChevronLeft} /> 戻る
    </WrapperLink>
  )
})

const style = css`
  color: ${Color.BRAND};
  margin: 32px 0 32px;
  display: block;
  border: none;
  font-size: 1rem;
  padding: 0;
  cursor: pointer;
`

const WrapperButton = styled.button`
  ${style}
`

const WrapperLink = styled(WrapperButton)`
  ${style}
`.withComponent(Link)
